import React, { memo, useState } from "react";
import EmptyApplianceFormView from "../EmptyApplianceFormView";
import AddedAppliance from "./components/AddedAppliance";
import styles from "./ApplianceOverview.module.scss";
import FormWrapper from "../../../../../../../common/components/form-wrapper/FormWrapper";
import { ApplianceItem } from "../../../../../../../model/solar-recommendation-form/appliance-item";

type Props = {
	appliances: ApplianceItem[];
	isVisibleButton: boolean;
	onChange: (appliances: ApplianceItem[]) => void;
	onFindAppliance: (appliance: ApplianceItem | undefined) => void;
	onBack: () => void;
	onSave: () => void;
};

const ApplianceOverview: React.FC<Props> = memo((props: Props) => {
	const { appliances, isVisibleButton, onChange, onFindAppliance, onSave } = props;

	function onEditAppliance(appliance: ApplianceItem) {
		const newAppliances = appliances.map(a => (a.id === appliance.id ? appliance : a));
		onChange(newAppliances);
	}

	function onRemoveAppliance(appliance: ApplianceItem) {
		const newAppliances = appliances.filter(a => a.id !== appliance.id);
		onChange(newAppliances);
	}

	function triggerFindAppliance() {
		onFindAppliance(undefined);
	}

	return appliances.length ? (
		<FormWrapper
			titleSection={{ title: "Appliance", subtitle: "Add home appliances to calculate your energy usage", buttonTitle: "Save & Continue" }}
			onSaveAndContinue={onSave}
		>
			<div className={styles.applianceContainer}>
				{appliances.map((appliance, index) => (
					<AddedAppliance key={index} appliance={appliance} onChanges={onEditAppliance} onRemove={onRemoveAppliance} onChangeAppliance={onFindAppliance} />
				))}
				{
					isVisibleButton
					&&
					<button className={`standardButton ${styles.addApplianceButton}`} onClick={triggerFindAppliance}>
						<span>+</span> Add another appliance
					</button>
				}
			</div>
		</FormWrapper>
	) : (
		<EmptyApplianceFormView onButtonClick={triggerFindAppliance} />
	);
});

export default ApplianceOverview;
